exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "coderreviewed h6{display:inline-block;margin-right:10px}coderreviewed h6:last-of-type{margin-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/reports/coderreviewed/coderreviewed.styl
// module id = 66
// module chunks = 1